
import React from 'react';

import { Formik } from 'formik';

import Grid from '@material-ui/core/Grid';

import HylyField from '../HylyField';


const Yup = require('yup');

const regex = {
  price: /(:?^-?|\s)(?=.)((?:0|(?:[1-9](?:\d*|\d{0,2}(?:,\d{3})*)))?(?:\.\d*[1-9])?)((%|\$)?)(?!\S)/,
  phone: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
  number: /^\d+$/,
  zip: /^\d{5}$/,
  url: /^(https?:\/\/(www\.)?|(www\.))?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
}

function get_prefix_validation (field, errors) {
  const schema = Yup.string()
  switch(field) {
    case "email": return schema[field](errors[field]);
    case "url":
    case "phone":
    case "number":
    case "zip":
    case "price": return schema.matches(regex[field],errors[field]);
    case "size": return schema.matches(regex.number,errors.size);
    case "text":
    default: return schema;
  }
}

const default_errors = {
  email: "Please enter a correct email.",
  url: "Please enter a value in the format <domain>/<path>.",
  phone: "Please enter a value in the format (111)111-1111.",
  number: "Please enter a number.",
  price: "Please enter a price.",
  zip: "Please enter a 5 digit number for zip.",
  required: field => `${field.replace(/(^[a-z])/,o => o.toUpperCase())} is required.`,
}


export function create_address_validations(field, errors) {
  const required_error = c => errors[`required_${field}.${c}`] || (errors.required && errors.required(c));
  return Yup.object().shape({
      ...["street", "city","state"].reduce((a,c) => ({ ...a, [c]: Yup.string().trim().required(required_error(c)) }),{}),
      zip: Yup.string().matches(regex.zip, errors.zip)
  })
}

export function create_array_validations(type, required_suffix, label, errors) {
  const schema = get_prefix_validation(type, errors);
  return Yup.array()
            .of( Boolean(required_suffix)
              ? schema.trim().required(
                  errors[`required_array_${type}`] ||
                  ( errors.required && errors.required(label||type) )
                )
              : schema
            )
}


export function create_validation(fields, errors = default_errors) {
  return Yup.object().shape(
    fields.reduce((acc, item) => {

      let type, name, required_suffix, field, label, variant;

      if (typeof item === "string") {
        [type, name, required_suffix] = item.split('__');
        field                         = item;
      }

      else if (typeof item === "object" && Object.hasOwnProperty.call(item, "type")) {
        // I am only supporting object validation for array type right now because it gets too messy otherwise
        // Navneet: please talk to me if you need more explanations on This

        variant         = item.variant;
        type            = item.type;
        name            = item.name;
        required_suffix = item.required;
        label           = item.label;
        field           = `${type}__${name}${required_suffix ? "__required":""}`
        console.log("field: ",field, "name: ",name);

      }

      if (variant === 'array') {
          const [,type_to_use] = type.split('_');
          return {
            ...acc,
            [field]: create_array_validations(type_to_use, required_suffix, label,errors)
          }
      }

      else if (type === "address") {
        return {
          ...acc,
          [field]: create_address_validations(field, errors)
        }
      }
      console.log("errors: ",errors);
      const schema = get_prefix_validation(type, errors);
      return {
        ...acc,
        [field]: Boolean(required_suffix)
                  ? schema.trim().required(
                      errors[`required_${name}`] ||
                      ( errors.required && errors.required(label || name) )
                   )
                  : schema
      }
    },{})
  )
}
